import { Container } from "react-bootstrap";
import UploadModel from "../components/UploadModel";
import { useTranslation } from "react-i18next";

export default function UploadModelPage() {
    const [t, i18n] = useTranslation("global");
    return (
        <>
            <Container>
                <h1 className="mt-5 mb-5">{t("upload.title")}</h1>
                <UploadModel />
            </Container>
        </>
    );
}
